export default __webpack_public_path__ + "static/media/NEW-FLAVOR.9669874f.png";